import {useContext} from "react"
import {LoadingPageTransition} from "../../components/App/LoadingPageTransition"
import {HomeRepoListing} from "../../components/Home/HomeRepoListing"
import {ReleaseNoteBlock} from "../../components/Home/ReleaseNoteBlock"
import {ProfileContext} from "../../context/Profile.context"
import styles from "./index.module.scss"

export const Home = () => {
  const {profile, profileReplCnt} = useContext(ProfileContext)

  if (!profile || profileReplCnt === undefined) {
    return <LoadingPageTransition/>
  }

  const release01 = {
    title: "Release 0.1",
    updateTime: "2022 Oct 31",
    imgUrl: "https://picsum.photos/200/300",
    description: `Follow the video tutorial above. Understand how to use each tool in 
    the Figma application. Also learn how to make a good and correct design. Starting from spacing, 
    typography, content, and many other design hierarchies. Then try to make it yourself 
    with your imagination and inspiration.`,
    highlights: [
      "List item A",
      "List item B",
      "List item C",
      "List item D"
    ]
  }

  return (
    <div className={styles.Container}>
      <div className={styles.UpdateContainer}>
        <div className={styles.RecentUpdateHeader}>DeGit Recent Updates</div>
        <ReleaseNoteBlock meta={release01}/>
      </div>

      <div className={styles.ReposContainer}>
        <div className={styles.YourProjectHeader}>Your recent projects</div>
        <HomeRepoListing profile={profile}/>
      </div>
    </div>
  )
}
